import { useEffect } from 'react';
import { applyPlatformFavicon } from '../utils/platformFavicon';

/**
 * Ensures the browser tab shows the Compete Pages favicon for signed-in / marketing app routes.
 */
export function usePlatformFavicon(): void {
  useEffect(() => {
    applyPlatformFavicon();
  }, []);
}
